module.exports = __webpack_public_path__ + "static/media/DIS_DOCUMENT_ACCEPTANCE_PENDING.b301db54.svg";